<template>
  <div class="w-100 text-center p-2">
    <div class="lds-ring">
      <div :style="{ width: w + 'px', height: w + 'px' }"></div>
      <div :style="{ width: w + 'px', height: w + 'px' }"></div>
      <div :style="{ width: w + 'px', height: w + 'px' }"></div>
      <div :style="{ width: w + 'px', height: w + 'px' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'spinner',
  props: ['w'],
};
</script>

<style scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #007bff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
